import { Record } from 'immutable';

const ChainRecord = Record({
    chainCode: null,
    name: null
});

export class Chain extends ChainRecord {
    chainCode: string;
    name: string;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/models/chain-brand/chain.ts